export default __webpack_public_path__ + "static/media/bg-mas.37dc6b9c.png";